import { freshCustomerListApi, freshAdviserStatisticsApi } from "@/libs/api.js";
// import { uleUrl, uleCdn, getCookie } from "@/libs/common";
// import bottomPop from "@/components/yzg/bottomPop.vue";
export default {
  name: "customerList",
  data() {
    return {
      searchValue: "",
      topNav: [
        {
          id: 0,
          name: "沉默顾客",
          number: 0,
        },
        {
          id: 1,
          name: "新顾客",
          number: 0,
        },
        {
          id: 2,
          name: "活跃顾客",
          number: 0,
        },
      ],
      topIndex: 0,
      query: {
        OrderType: 1,
        customerType: 0,
        pageIndex: 1,
        pageSize: 10,
        clientCallType: "H5",
      },
      defaultAvatar: "https://pic.ulecdn.com/itempic_188x188.GIF",
      list: [],
      listStatus: 1, // 列表状态 0-初始 1-有数据 2-无数据
      finishedText: "加载中...",
      isLoad: false,
      finished: false,
      loading: false,
      topData: {},
      freshType: 1,
      show: false,
      currentYear: "",
    };
  },

  mounted() {
    // this.freshType = this.$route.query.type;
    this.currentYear = this.$moment(Date.now()).format("YYYY");
    this.getFreshAdviserStatistics();
    this.getFreshCustomerList();
  },
  methods: {
    handleNav(item) {
      console.log(item);
      this.topIndex = item.id;
      this.query.customerType = item.id;
      this.query.pageIndex = 1;
      this.listStatus = 0;
      this.list = [];
      this.getFreshCustomerList();
    },
    searchList() {
      console.log("回车", this.searchValue);
    },
    // 顾客统计
    getFreshAdviserStatistics() {
      freshAdviserStatisticsApi({ clientCallType: "H5", type: 1, freshType: this.freshType }).then((res) => {
        this.topData = res.data;
        if (this.topData) {
          this.topNav[0].number = this.topData.latentCustomer || 0;
          this.topNav[1].number = this.topData.newCustomer || 0;
          this.topNav[2].number = this.topData.hotCustomer || 0;
        }
      });
    },
    // 顾客列表
    getFreshCustomerList() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      freshCustomerListApi(this.query).then((res) => {
        this.$toast.clear();
        this.loading = false;
        this.finished = false;
        if (res.returnCode == "0000" && res.data && res.data.freshCustomerInfoRess) {
          this.list = this.list.concat(res.data.freshCustomerInfoRess);
          this.list.length > 0 ? (this.listStatus = 1) : (this.listStatus = 2);
          if (this.query.pageIndex == res.data.totalPage) {
            this.finished = true;
            this.finishedText = "我已到达底部, 暂无其他数据啦~~";
          } else {
            this.finished = false;
            this.query.pageIndex++;
          }
        } else {
          this.listStatus = 2;
          this.finished = true;
        }
      });
    },
    handleChangeNumber() {
      if (this.query.OrderType == 1) {
        this.query.OrderType = 2;
      } else if (this.query.OrderType == 2) {
        this.query.OrderType = 1;
      } else {
        this.query.OrderType = 1;
      }
      this.query.pageIndex = 1;
      this.list = [];
      this.listStatus = 0;
      this.getFreshCustomerList();
    },
    handleChangeHistory() {
      if (this.query.OrderType == 3) {
        this.query.OrderType = 4;
      } else if (this.query.OrderType == 4) {
        this.query.OrderType = 3;
      } else {
        this.query.OrderType = 3;
      }
      this.query.pageIndex = 1;
      this.list = [];
      this.listStatus = 0;
      this.getFreshCustomerList();
    },
    handleGoIndex() {
      window.location.href = "ulemobile://uleHomepage";
    },
  },
};
